module.exports = __webpack_public_path__ + "static/media/crabapple.54d42be4.jpg";